import { env } from '@/lib/env';

/** Insignia de entorno (equivale a la de `framebody/footer.php`): oculta en producción. */
export function InsigniaEntorno() {
  if (env.appEnv === 'prod') return null;
  const etiqueta = env.appEnv === 'qa' ? 'QA' : 'LOCAL';
  return (
    <div
      className="pointer-events-none fixed bottom-20 left-3 z-50 rounded-full bg-amarillo-400 px-3 py-1 text-xs font-extrabold tracking-widest text-noche-950 shadow-lg lg:bottom-3"
      aria-hidden
    >
      {etiqueta}
    </div>
  );
}
